import { render, staticRenderFns } from "./ComposerAttachments.vue?vue&type=template&id=44ae67a0&scoped=true&"
import script from "./ComposerAttachments.vue?vue&type=script&lang=js&"
export * from "./ComposerAttachments.vue?vue&type=script&lang=js&"
import style0 from "./ComposerAttachments.vue?vue&type=style&index=0&id=44ae67a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ae67a0",
  null
  
)

export default component.exports